import { render, staticRenderFns } from "./MinMaxReport.vue?vue&type=template&id=8cc53160&"
import script from "./MinMaxReport.vue?vue&type=script&lang=js&"
export * from "./MinMaxReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports